<template>
	<div>
		<b-modal ref="modelRef" id="img_modal" title="Image">
			<b-container fluid>
				<img :src="item" style="width:100%;" />
			</b-container>
			<div slot="modal-footer">
				<b-button type="button" variant="primary" data-dismiss="modal" @click="onClose()">Close</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
export default {
	props: {
		item: ''
	},
	methods: {
		onClose() {
			this.$refs.modelRef.hide()
		}
	}
}
</script>